import { render, staticRenderFns } from "./password-confirmation.vue?vue&type=template&id=2fe31be4&lang=pug&"
import script from "./password-confirmation.vue?vue&type=script&lang=js&"
export * from "./password-confirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports